import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { BottomDrawer } from '$common/bottom-drawer'
import { InstallTwa } from '$comp/install-twa'
import { nothing } from '$func/utils'

export function RecommendInstallTwa({ isOpen }: { isOpen: boolean }) {
  return (
    <BottomDrawer isOpen={isOpen} onClose={nothing} isFullscreen>
      <InstallTwa isOpen mode="UPDATE" onClose={closeCurrentModal} />
    </BottomDrawer>
  )
}
